<form [formGroup]="parentForm" (ngSubmit)="parentSubmit()" class="dialog">
    <igx-input-group type="border">
        <label igxLabel>Име и фамилия на родителя</label>
        <input igxInput [igxTextSelection]="true" name="name" formControlName="name" />
        <igx-hint *ngIf="!secondParent && request?.parentName && parent">{{ request?.parentName }}</igx-hint>
        <igx-hint *ngIf="secondParent && request?.secondParentName && parent">{{ request?.secondParentName }}</igx-hint>
    </igx-input-group>
    <igx-input-group type="border">
        <label igxLabel>Имейл</label>
        <input igxInput [igxTextSelection]="true" name="email" formControlName="email" />
        <igx-hint *ngIf="!secondParent && request?.parentEmail && parent">{{ request?.parentEmail }}</igx-hint>
    </igx-input-group>
    <igx-input-group type="border">
        <label igxLabel>Телефон</label>
        <input igxInput [igxTextSelection]="true" name="phone" formControlName="phone" />
        <igx-hint *ngIf="!secondParent && request?.parentPhone && parent">{{ request?.parentPhone }}</igx-hint>
        <igx-hint *ngIf="secondParent && request?.secondParentPhone && parent">{{ request?.secondParentPhone }}</igx-hint>
    </igx-input-group>
    <igx-select name="parentType" formControlName="parentType" type="border">
        <label igxLabel>Тип</label>
        <igx-select-item *ngFor="let type of parentTypes" [value]="type">{{ type }}</igx-select-item>
    </igx-select>
    <igx-combo name="kids" formControlName="kids" type="border" [data]="kids | sorting" [displayKey]="'name'" [valueKey]="'id'">
        <label igxLabel>Деца</label>
    </igx-combo>
    <igx-dialog-actions>
        <button igxButton type="button" (click)="done.emit()">ОТКАЖИ</button>
        <button igxButton type="submit">{{ dialogText }}</button>
    </igx-dialog-actions>
</form>
